import React from "react";

export function TablaPromedios({ area, preguntas }) {

  function formatter(valor) {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
  }

  return (
    <table key={"t_" + area.idarea} className='table table-striped' aria-labelledby="tabelLabel">
      <thead>
        <tr key={"h1"}><th colSpan={5} className="text-center">{area.area}</th></tr>
        <tr key={"h2"}>
          <th className="text-right">N°</th>
          <th className="text-center">Pregunta</th>
          <th className="text-center">Media</th>
          <th className="text-center">Desviación estándar</th>
          <th className="text-center">Puntaje obtenido</th>
        </tr>
      </thead>
      <tbody>
        {preguntas.map((p, index) =>
          <tr key={p.idparalelo + "_" + p.idpregunta}>
            <td className="text-right">{index+1}</td>
            <td>{p.pregunta}</td>
            <td className="text-center">{formatter(p.media)}</td>
            <td className="text-center">{formatter(p.desviacionestandar)}</td>
            <td className="text-center">{formatter(p.porcentaje * 100.0) + " %"}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}